import { render, staticRenderFns } from "./StudentAttendanceReport.vue?vue&type=template&id=bb2abdc4&scoped=true"
import script from "./StudentAttendanceReport.vue?vue&type=script&lang=js"
export * from "./StudentAttendanceReport.vue?vue&type=script&lang=js"
import style0 from "./StudentAttendanceReport.vue?vue&type=style&index=0&id=bb2abdc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb2abdc4",
  null
  
)

export default component.exports